import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { IGetCmsUsefulInformationActionParams } from "../../../Orchestrator/Types/Interface/ICmsUsefulInformaton";

class UsefulInfoCardClickAction extends BaseAction<void, IGetCmsUsefulInformationActionParams> {
    override async run(): Promise<void> {
        const { slug } = this.params!;
        _eventBus.emit({
            eventName: "ROUTE_CHANGE",
            data: `/useful-information/${slug}`,
        })
    }
}

export const usefulInfoCardClickAction = new UsefulInfoCardClickAction();
